/**
 * Copyright (c) 2026, CheckPlus Limited
 */
import React, { Component } from "react";
import "./HomepageMenuEn.css";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";

class HomepageMenuEn extends Component {
  render() {
    return (
      <div className="HomepageMenuEn-main">
        <div className="HomepageMenuEn-leftContainer">
          <div className="HomepageMenuEn-outsideHeader">
            <div className="HomepageMenuEn-navBar">
              <div
                className="HomepageMenuEn-menuBtn"
                onClick={() => this.props.closeModal()}
              >
                <div className="HomepageMenuEn-menuIcn" />
              </div>

              <div className="HomepageMenuEn-CheckPlusLogo" />

              <div className="HomepageMenuEn-navBarContainer">
                <Link to="/En">
                  <div className="HomepageMenuEn-settingsContainer">
                    <div className="HomepageMenuEn-settingsTxt">Overview</div>
                  </div>
                </Link>

                <Link to="/EnWhyCheckPlus">
                  <div className="HomepageMenuEn-settingsContainer">
                    <div className="HomepageMenuEn-settingsTxt">
                      Why CheckPlus?
                    </div>
                  </div>
                </Link>

                <Link to="/EnSecurity">
                  <div className="HomepageMenuEn-settingsContainer">
                    <div className="HomepageMenuEn-settingsTxt">Security</div>
                  </div>
                </Link>

                <Link to="/EnPricing">
                  <div className="HomepageMenuEn-settingsContainer">
                    <div className="HomepageMenuEn-settingsTxt">Pricing</div>
                  </div>
                </Link>

                <Link to="/EnFaq">
                  <div className="HomepageMenuEn-settingsContainer">
                    <div className="HomepageMenuEn-settingsTxt">FAQ</div>
                  </div>
                </Link>

                <Link to="/OrgLogin">
                  <div className="HomepageMenuEn-loginContainer">
                    <div className="HomepageMenuEn-loginTxt">Log In</div>
                  </div>
                </Link>

                <Link to="/OrgSignup">
                  <div className="HomepageMenuEn-signUpContainer">
                    <div className="HomepageMenuEn-signupTxt">Sign Up</div>
                  </div>
                </Link>
              </div>
            </div>
          </div>
        </div>
        <div className="HomepageMenuEn-bg" />
      </div>
    );
  }
}

HomepageMenuEn.propTypes = {
  show: PropTypes.bool,
  closeModal: PropTypes.func,
  state: PropTypes.object,
};

export default HomepageMenuEn;
